module.exports = __webpack_public_path__ + "img/logo-government-4.f220c66b.png";